import { IBANContext } from "@usher/pe-client-front-end-lib"
import { Fragment, useContext, useState } from "react"
import { PageTitle } from "../sections/PageTitle"
import { PaymentSystemSelect } from "./PaymentSystem"
import { Stepper } from "./Stepper"
import { Transfer } from "./TransferForm"
const STEPS = [{ label: "1" }, { label: "2" }]
export const NewPayment = () => {
  const { currency, paymentSystem, setPaymentSystem } = useContext(IBANContext)
  const [currentStep, setCurrentStep] = useState(1)
  return (
    <Fragment>
      <PageTitle title="New Payment" />
      <PaymentSystemSelect onChange={setPaymentSystem} value={paymentSystem} disabled={currentStep > 1} />
      <Stepper steps={STEPS} currentStep={currentStep} className="mt-[50px]" />
      <Transfer currentStep={currentStep} onNext={setCurrentStep} {...{ paymentSystem, currency }} />
    </Fragment>
  )
}
